export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-b from-[#0d1f3c] to-[#0a1628] py-12 px-4 sm:px-6 lg:px-8 border-t border-cyan-500/20">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-8">
          <div className="mb-6 md:mb-0">
            <img
              src="https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/43884c505bd2c9515d324bd839f9d0c8.jpeg"
              alt="Joysticks, Pixels & Pour"
              className="h-16 w-auto"
            />
          </div>

          <div className="flex items-center space-x-6">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500/20 to-orange-500/20 rounded-lg hover:from-pink-500/40 hover:to-orange-500/40 transition-all duration-300 hover:scale-110 cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl text-pink-400"></i>
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg hover:from-cyan-500/40 hover:to-blue-500/40 transition-all duration-300 hover:scale-110 cursor-pointer"
            >
              <i className="ri-facebook-fill text-2xl text-cyan-400"></i>
            </a>
            <a
              href="https://tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500/20 to-pink-500/20 rounded-lg hover:from-cyan-500/40 hover:to-pink-500/40 transition-all duration-300 hover:scale-110 cursor-pointer"
            >
              <i className="ri-tiktok-line text-2xl text-cyan-400"></i>
            </a>
          </div>
        </div>

        {/* Neon divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent mb-8"></div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
          <p className="mb-4 md:mb-0">
            © {currentYear} Joysticks, Pixels &amp; Pour — Press Start for Good Times
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyan-400 hover:text-pink-400 transition-colors duration-300 cursor-pointer"
          >
           
          </a>
        </div>
      </div>
    </footer>
  );
}
